/**
 * Функция getCoursesById(courses) переформатирует json с курсами из стандартных форм TL_FORM, ORDER_FORM
 *
 * получает объект 'courses' ($scope.form.courses) из форм заказов и пробных уроков
 * возвращает объект, где в ключах id курсов, а в значениях - объекты с данными этих курсов из полученного obj. courses
 *
 * @param object
 * @return object
 */

function getCoursesById(courses) {
    var coursesById = {};
    var i;
    var j;

    for (i in courses) {
        for (j in courses[i]) {
            var id = courses[i][j].id;
            coursesById[id] = courses[i][j];
        }
    }
    return coursesById;
}

// Возвращает подмножество courses{} (сохраняя исходный формат) по заданным types[] (offline, pdf, online)
function getCoursesByTypes(courses, types) {
    var filteredCourses = {};
    var cat; // категория
    for (cat in courses) {
        var arr = courses[cat].filter(function(item) {
            return types.indexOf(item.course_type) != -1;
        });
        if (arr.length > 0) {
            filteredCourses[cat] = arr;
        }
    }
    return filteredCourses;
}
